'use strict';

const 
    searchContainer: HTMLAnchorElement|null = document.querySelector('.banner-search'),
    bannerWrapper: HTMLDivElement|null = document.querySelector('.site-banner-wrapper--container')

if(searchContainer!=null && bannerWrapper!=null){
    startSearch(searchContainer,bannerWrapper)
}

function startSearch(searchContainer:HTMLAnchorElement,bannerWrapper:HTMLDivElement){
    const
        searchIcon: HTMLDivElement|null = document.querySelector('.banner-search-icon'),
        closer = searchContainer.querySelector('.closer'),
        searchField: HTMLInputElement|null = searchContainer.querySelector('input');

    searchIcon?.addEventListener('click', function (event) {
        event.preventDefault();
        if (bannerWrapper.classList.contains('search')) return;
        bannerWrapper.classList.add('search');
        setTimeout(function () {
            searchContainer.querySelector('input')?.focus();
        }, 300);
    });

    searchField?.addEventListener('search', (_e) => {
        window.location.href = '/search/?query=' + searchField.value
    })
    searchField?.addEventListener('keyup', e => {
        var key = e.key || e.code;
        if (e.defaultPrevented) return;
        if (key === 'Enter') window.location.href = '/search/?query=' + searchField.value
    })

    closer?.addEventListener('click', function () {
        bannerWrapper.classList.remove('search');
    });
}